import { classNames } from '@utils/genUtils'
import React from 'react'
import { twMerge } from 'tailwind-merge'
interface Props {
  subHeaderClassNames?: string
  h2ClassNames?: string
  content: {
    subheader: string
    title: string
    text: string
    quote?: {
      cite: string
      quoteColor?: string
    }
  }
}

export default function HeaderQuoteB(props: Props) {
  const { content: { subheader, title, text, quote }, subHeaderClassNames, h2ClassNames } = props
  return (
    <div className='px-0 et-fluid-grid gap-y-0 md:px-0 md:gap-y-2'>
      <div className={twMerge('lfm2020-fontProcess__subhead col-start-2 col-span-2 text-center text-xl md:col-start-2 md:col-span-12', subHeaderClassNames ? subHeaderClassNames : '')}>
        {subheader}
      </div>

      <h2 className={twMerge('font-sentinel__SemiBoldItal text-4xl md:text-5xl text-center col-start-2 col-span-2 mx-auto mt-0 mb-5 relative z-2 md:col-start-4 md:col-span-8 lg:mb-4 lg:mx-8 xl:text-6xl', h2ClassNames ? h2ClassNames : '')}>
        {title}
      </h2>
    </div>
  )
}
